'use strict';

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function compact(array) {
  if (!(0, _isArray["default"])(array)) {
    return [];
  }

  return array.filter(Boolean);
};